'use client';

import Link from 'next/link';
import { Card, CardContent } from '@/src/components/ui/card';

interface IPASymbolCardProps {
  id: string;
  symbol: string;
  colorClass?: string;
}

export function IPASymbolCard({ id, symbol, colorClass = '' }: IPASymbolCardProps) {
  return (
    <Link href={`/speaking/pronunciation/ipa/${id}`}>
      <Card
        className={`flex aspect-square cursor-pointer flex-col items-center justify-center rounded-lg border-2 p-4 transition-colors ${colorClass}`}
      >
        <CardContent className='p-4 text-center'>
          <div className='text-2xl font-bold'>{symbol}</div>
        </CardContent>
      </Card>
    </Link>
  );
}
